const trimTrailingSlash = (url) => url.replace(/\/+$/, "");

const ensureLeadingSlash = (path) => (path.startsWith("/") ? path : `/${path}`);

const backendHttpBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_BACKEND_HTTP_URL || "http://localhost:8000"
);

const backendWsBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_BACKEND_WS_URL || "ws://localhost:8000"
);

export const GRAPHQL_HTTP_URL =
  process.env.REACT_APP_GRAPHQL_HTTP_URL || "http://localhost:4000/graphql";

export const GRAPHQL_WS_URL =
  process.env.REACT_APP_GRAPHQL_WS_URL || "ws://localhost:4000/graphql";

export const CODE_EXECUTOR_WS_URL = trimTrailingSlash(
  process.env.REACT_APP_CODE_EXECUTOR_WS_URL || "ws://localhost:27027"
);

export const API_DOC_URL = `${backendHttpBaseUrl}/apidoc`;
export const EXAMPLE_CONNECTOR_URL = `${backendHttpBaseUrl}/connector`;

export const buildApiUrl = (path) =>
  `${backendHttpBaseUrl}${ensureLeadingSlash(path)}`;

export const buildWsUrl = (path) =>
  `${backendWsBaseUrl}${ensureLeadingSlash(path)}`;
